/**
 * Форматирует ошибки валидации с сервера для отображения в формах
 * 
 * @param serverErrors - Объект с ошибками от сервера (может содержать массивы строк)
 * @param fieldMapping - Маппинг ключей сервера на ключи формы (например, { title: 'courseName' })
 * @returns Объект с отформатированными ошибками (все значения - строки)
 * 
 * @example
 * formatServerErrors(
 *   { title: ["Убедитесь, что это значение содержит не более 400 символов."] },
 *   { title: 'courseName' }
 * )
 * // Returns: { courseName: "Убедитесь, что это значение содержит не более 400 символов." }
 */
export function formatServerErrors(
  serverErrors: Record<string, any>,
  fieldMapping?: Record<string, string>
): Record<string, string> {
  const formattedErrors: Record<string, string> = {};

  for (const key in serverErrors) {
    if (serverErrors.hasOwnProperty(key)) {
      const errorValue = serverErrors[key];
      let errorMessage = '';

      // Обработка разных форматов ошибок
      if (Array.isArray(errorValue)) {
        // Если ошибка - массив, берем первый элемент
        errorMessage = errorValue.length > 0 ? String(errorValue[0]) : '';
      } else if (typeof errorValue === 'string') {
        // Если ошибка - строка, используем её как есть
        errorMessage = errorValue;
      } else if (errorValue && typeof errorValue === 'object') {
        // Если ошибка - объект, пытаемся преобразовать в строку
        errorMessage = JSON.stringify(errorValue);
      } else {
        // Для других типов преобразуем в строку
        errorMessage = String(errorValue || '');
      }

      // Применяем маппинг ключей, если он указан
      const formFieldName = fieldMapping && fieldMapping[key] ? fieldMapping[key] : key;
      
      if (errorMessage) {
        formattedErrors[formFieldName] = errorMessage;
      }
    }
  }

  return formattedErrors;
}

